<template>
    <div>
        <div class="home-list">

<!--            <div class="home-icon-box" @click="clickIconFunc('material')">-->
<!--                <div class="icon-part">-->
<!--                    <span><font-awesome-icon icon="fa-solid fa-boxes-stacked" /></span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span tkey="產品管理" class="icon-text">{{i18n.tkey("lang_product_manager")}}</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="home-icon-box" @click="clickIconFunc('payment')">-->
<!--                <div class="icon-part">-->
<!--                    <span><font-awesome-icon icon="fa-regular fa-credit-card" /></span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span tkey="收款方式" class="icon-text">{{i18n.tkey("lang_receive_method_1")}}</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="home-icon-box" @click="clickIconFunc('delivery')">-->
<!--                <div class="icon-part">-->
<!--                    <span><font-awesome-icon icon="fa-solid fa-truck" /></span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span tkey="運輸管理" class="icon-text">{{i18n.tkey("lang_transport_manage")}}</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <a :href="orderUrl" target="eshopopee">-->
<!--                <HomeIconBoxShadow-->
<!--                    :label="i18n.tkey('lang_order_manage')"-->
<!--                    tkey="訂單管理"-->
<!--                >-->
<!--                    <font-awesome-icon icon="fa-solid fa-file-lines" />-->
<!--                </HomeIconBoxShadow>-->
<!--            </a>-->

<!--            <HomeIconBoxDetail-->
<!--                :label="i18n.tkey('lang_hall_manager_1')"-->
<!--                :detail="'&nbsp;'"-->
<!--                @click="clickIconFunc('hall')"-->
<!--                tkey="展會管理"-->
<!--            >-->
<!--                <font-awesome-icon icon="fa-solid fa-users" />-->
<!--            </HomeIconBoxDetail>-->

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_my_inv')"
                :detail="'&nbsp;'"
                @click="clickIconFunc('inv')"
                tkey="我的邀請"
            >
                <font-awesome-icon icon="fa-solid fa-handshake-simple" />
            </HomeIconBoxDetail>

           <HomeIconBoxDetail
              :label="i18n.tkey('lang_my_agent')"
               :detail="'&nbsp;'"
               @click="clickIconFunc('agent')"
               tkey="我的代理"
            >
                <font-awesome-icon icon="fa-solid fa-boxes-packing" />
         </HomeIconBoxDetail>

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_my_video')"
                :detail="'&nbsp;'"
                @click="clickIconFunc('ads')"
                tkey="我的視頻"
            >
                <font-awesome-icon icon="fa-solid fa-photo-film" />
            </HomeIconBoxDetail>

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_3d_shop_share')"
                :detail="'&nbsp;'"
                @click="clickIconFunc('share')"
                tkey="3D店鋪分享"
            >
                <font-awesome-icon icon="fa-solid fa-share-nodes" />
            </HomeIconBoxDetail>


            <!--            <div class="home-icon-box" @click="clickIconFunc('hall')">-->
            <!--                <div class="icon-part">-->
            <!--                    <span><font-awesome-icon icon="fa-solid fa-users" /></span>-->
            <!--                </div>-->

            <!--                <div>-->
            <!--                    <span tkey="展會管理" class="icon-text">{{i18n.tkey("lang_hall_manager_1")}}</span>-->
            <!--                </div>-->
            <!--            </div>-->

        </div>

        <div class="home-list" style="margin-top: 32px">
            <HomeIconBoxShadow
                :label="i18n.tkey('lang_company_info')"
                @click="clickIconFunc('company')"
                tkey="公司信息"
            >
                <font-awesome-icon icon="fa-solid fa-building" />
            </HomeIconBoxShadow>

            <!--            <div class="home-icon-box" @click="clickIconFunc('company')">-->
            <!--                <div class="icon-part">-->
            <!--                    <span><font-awesome-icon icon="fa-solid fa-building" /></span>-->
            <!--                </div>-->

            <!--                <div>-->
            <!--                    <span tkey="公司信息" class="icon-text">{{i18n.tkey("lang_company_info")}}</span>-->
            <!--                </div>-->
            <!--            </div>-->

            <a
                :href="customerUrl"
                target="eshopopee"
                v-if="hideEshopopeeFlag"
            >
                <HomeIconBoxShadow
                    :label="i18n.tkey('lang_customer_manage')"
                    tkey="客戶管理"
                >
                    <font-awesome-icon icon="fa-solid fa-user-tie" />
                </HomeIconBoxShadow>

                <!--                <div class="home-icon-box">-->
                <!--                    <div class="icon-part">-->
                <!--                        <span><font-awesome-icon icon="fa-solid fa-user-tie" /></span>-->
                <!--                    </div>-->

                <!--                    <div>-->
                <!--                        <span tkey="客戶管理" class="icon-text">{{i18n.tkey("lang_customer_manage")}}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
            </a>

            <a
                :href="productUrl"
                target="eshopopee"
                v-if="hideEshopopeeFlag"
            >
                <HomeIconBoxShadow
                    :label="i18n.tkey('lang_product_manager')"
                    tkey="產品管理"
                >
                    <font-awesome-icon icon="fa-solid fa-boxes-stacked" />
                </HomeIconBoxShadow>

                <!--                <div class="home-icon-box">-->
                <!--                    <div class="icon-part">-->
                <!--                        <span><font-awesome-icon icon="fa-solid fa-boxes-stacked" /></span>-->
                <!--                    </div>-->

                <!--                    <div>-->
                <!--                        <span tkey="產品管理" class="icon-text">{{i18n.tkey("lang_product_manager")}}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
            </a>

            <a
                :href="webDesignUrl"
                target="eshopopee"
                v-if="hideEshopopeeFlag"
            >
                <HomeIconBoxShadow
                    :label="i18n.tkey('lang_website_manage')"
                    tkey="網站管理"
                >
                    <font-awesome-icon icon="fa-solid fa-network-wired" />
                </HomeIconBoxShadow>
            </a>


            <HomeIconBoxShadow
                :label="i18n.tkey('lang_delivery_remark')"
                @click="clickIconFunc('remark')"
                v-if="hideEshopopeeFlag"
                tkey="運輸備註"
            >
                <font-awesome-icon icon="fa-solid fa-file-lines" />
            </HomeIconBoxShadow>

<!--            <div class="home-icon-box" @click="clickIconFunc('remark')">-->
<!--                <div class="icon-part">-->
<!--                    <span><font-awesome-icon icon="fa-solid fa-file-lines" /></span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span tkey="運輸備註" class="icon-text">{{i18n.tkey("lang_delivery_remark")}}</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="home-icon-box" @click="clickIconFunc('inv')">-->
<!--                <div class="icon-part">-->
<!--                    <span><font-awesome-icon icon="fa-solid fa-handshake-simple" /></span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span tkey="我的邀請" class="icon-text">{{i18n.tkey("lang_my_inv")}}</span>-->
<!--                </div>-->
<!--            </div>-->

            <a
                :href="orderUrl"
                target="eshopopee"
                v-if="hideEshopopeeFlag"
            >
                <HomeIconBoxShadow
                    :label="i18n.tkey('lang_order_i_received')"
                    tkey="我收的單"
                >
                    <font-awesome-icon icon="fa-solid fa-file-lines" />
                </HomeIconBoxShadow>
            </a>

            <a
                :href="purchaseUrl"
                target="eshopopee"
                v-if="hideEshopopeeFlag"
            >
                <HomeIconBoxShadow
                    :label="i18n.tkey('lang_order_i_placed')"
                    tkey="我下的單"
                >
                    <font-awesome-icon icon="fa-solid fa-file" />
                </HomeIconBoxShadow>
            </a>
        </div>

    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBuilding, faBoxesStacked, faTruck, faFileLines, faUsers, faHandshakeSimple, faGlobe, faUserTie, faFile, faPhotoFilm, faShareNodes, faComments,faNetworkWired, faBoxesPacking } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'
import {inject, computed, toRef, getCurrentInstance, ref, onBeforeMount} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import HomeIconBoxShadow from "@/components/shopopee/common/homeIconBoxShadow.vue";
import HomeIconBoxDetail from "@/components/shopopee/common/homeIconBoxDetail.vue";

library.add(faBuilding, faBoxesStacked, faCreditCard, faTruck, faFileLines, faUsers, faHandshakeSimple, faGlobe, faUserTie, faFile, faPhotoFilm, faShareNodes, faComments,faNetworkWired, faBoxesPacking)

const emits = defineEmits(["clickBtn"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")

const { proxy } = getCurrentInstance()

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

const shopCompany = ref({})


// const eshopopeeURL = computed(() => {
//     return myUtil.generateEshopopeeManagerUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword)
// })

// const websiteUrl = computed(() => {
//     return myUtil.generateEShopopeeShopUrl(shopCompany.value.acccompanycode)
// })

const orderUrl = computed(() => {
    const host = myUtil.isEmpty(shopCompany.value.currentcapital) ? proxy.$EShopopeeUrl : shopCompany.value.currentcapital

    return myUtil.generateEshopopeeManagerJumpUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "CRMSalesRecords.asp?shopForm=shopopee", host)
})

const productUrl = computed(() => {
    const host = myUtil.isEmpty(shopCompany.value.currentcapital) ? proxy.$EShopopeeUrl : shopCompany.value.currentcapital

    return myUtil.generateEshopopeeManagerJumpUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "BasicMaterialRecords.asp?shopForm=shopopee", host)
})

const customerUrl = computed(() => {
    const host = myUtil.isEmpty(shopCompany.value.currentcapital) ? proxy.$EShopopeeUrl : shopCompany.value.currentcapital

    return myUtil.generateEshopopeeManagerJumpUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "BasicCustomerRecords.asp?shopForm=shopopee", host)
})

const purchaseUrl = computed(() => {
    const host = myUtil.isEmpty(shopCompany.value.currentcapital) ? proxy.$EShopopeeUrl : shopCompany.value.currentcapital

    return myUtil.generateEshopopeeManagerJumpUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "SupplyPurchaseRecords.asp?shopForm=shopopee", host)
})

const webDesignUrl = computed(() => {
    const host = myUtil.isEmpty(shopCompany.value.currentcapital) ? proxy.$EShopopeeUrl : shopCompany.value.currentcapital

    return myUtil.generateEshopopeeManagerJumpUrl(shopCompany.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "MemberWebDesign.asp?shopForm=shopopee", host)
})


const hideEshopopeeFlag = computed(() => {
    let flag = false

    flag = shopCompany.value.dinumber == -1

    return !flag
})

function clickIconFunc(name){
    emits("clickBtn", name)
}


onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()

})

</script>

<style scoped>
    .home-list {
        display: flex;
        flex-wrap: wrap;
    }

    .home-icon-box {
        width: 90px;
        text-align: center;
        user-select: none;
        cursor: pointer;
        margin: 10px;
        box-sizing: border-box;
        border: 1px #E4E7ED solid;
        border-radius: 4px;
        padding-top: 14px;
        padding-bottom: 8px;
        background: #fafafa;
        box-shadow: 0px 5px 5px -5px #02A7F0;
    }

    .icon-part {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;

    }

    .icon-text {
        font-size: 12px;
        line-height: 2;
    }

    a:-webkit-any-link {
        color: unset;
        cursor: pointer;
        text-decoration: none;
    }

    a {
        color: unset;
        cursor: pointer;
        text-decoration: none;
    }
</style>